export default __webpack_public_path__ + "static/pre-order-cd924fd6727fdd9966fdf479f3bfe8f5.webp";